import { store } from "@store";
import { openDialog } from "@store/dialogs";

import {
  type IMediaLibDialogProps,
  MediaLibDialog,
} from "../components/media-lib-dialog";
import { useMediaLibDialogStore } from "../stores";
import {
  MediaLibCategoryEnum,
  MediaLibPresetEnum,
  type MediaPanelTabEnum,
} from "../types";

interface IProps extends IMediaLibDialogProps {
  category?: MediaPanelTabEnum;
  source?: "default" | "settings";
}

export const openMediaLibDialog = ({
  category,
  preset,
  source,
  ...props
}: IProps = {}) => {
  if (preset === MediaLibPresetEnum.OnlyImages) {
    useMediaLibDialogStore.getState().setCategory(MediaLibCategoryEnum.Images);
  }

  if (preset === MediaLibPresetEnum.OnlyVideos) {
    useMediaLibDialogStore.getState().setCategory(MediaLibCategoryEnum.Videos);
  }

  store.dispatch(
    openDialog({
      id: MediaLibDialog.dialogId,
      content: MediaLibDialog,
      props: { ...props, preset, source, category },
      closeOnOutsideClick: true,
    }),
  );
};
